import KAccountButton from "kinnect-general/KAccountButton";
import KBreadcrumbs from "@/components/App/KBreadcrumbs/KBreadcrumbs";
import KToolbarActions from "./KToolbarActions";
import {
	VAppBar,
	VAppBarNavIcon,
	VImg,
	VSpacer,
	VToolbarItems,
	VTooltip
} from "vuetify/lib";

export default {
	name: "KToolbar",

	computed: {
		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		},

		genLogo() {
			const src = this.$vuetify.breakpoint.smAndUp
				? require( "@/assets/logos/logo-small.png" )
				: require( "@/assets/logos/logo-icon.png" );

			return <VImg src={src}></VImg>;
		}
	},

	render() {
		if ( !this.isAuthenticated ) {
			return;
		}

		return <VAppBar
			app
			class="d-print-none"
			dense
			hideOnScroll
			scrollOffScreen
		>
			<VAppBarNavIcon
				onClick={() => this.$store.dispatch( "app/toggleDrawer" )}
			></VAppBarNavIcon>

			<VTooltip
				bottom
				scopedSlots={{
					activator: ( { on } ) =>
						<router-link on={on} to={{ name: "front" }}>
							{this.genLogo}
						</router-link>
				}}
			>Return to Kinnect home</VTooltip>

			<VSpacer></VSpacer>

			<VToolbarItems>
				<KToolbarActions></KToolbarActions>
				<KAccountButton></KAccountButton>
			</VToolbarItems>

			<KBreadcrumbs slot="extension"></KBreadcrumbs>
		</VAppBar>;
	}
};
